import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';
import { Colors, Router } from '@lightningjs/sdk';
import SidebarItem from './SidebarItem';
export const sidebarLinks = [
  { id: 1, title: 'Profile', image: '', height: 38, path: 'profile' },
  { id: 2, title: 'Search', image: '/images/search.svg', height: 29, path: 'search' },
  { id: 3, title: 'Home', image: '/images/home.svg', height: 34, path: 'browse' },
  { id: 4, title: 'My List', image: '/images/my-list.svg', height: 38, path: 'my-list' },
  { id: 5, title: 'New', image: '/images/new.svg', height: 38, path: 'new' },
  { id: 6, title: 'Settings', image: '/images/settings.svg', height: 38, path: 'settings' },
];
let sidebarLength = sidebarLinks.length;
let index = 0;
export default class SidebarItems extends Lightning.Component {
  static _template() {
    return {
      x: 60,
      zIndex: 200,
      Column: {
        type: Column,
        collision: true,
        plinko: true,
        items: sidebarLinks.map((item) => ({
          collision: true,
          type: SidebarItem,
          zIndex: 200,
          plinko: true,
          h: 80,
          flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
          color: Colors('#FFFFFF').get(),
          item,
        })),
      },
    };
  }
  _init() {
    this._selectedLink = this._Column;
  }

  _active() {
    this._Column.selectedIndex = this._setManualFocus();
  }
  _setManualFocus() {
    switch (Router.getActiveHash()) {
      case 'search':
        index = 1;
        return index;
      case 'browse':
        index = 2;
        return index;
      case 'my-list':
        index = 3;
        return index;
      case 'new':
        index = 4;
        return index;
      case 'settings':
        index = 5;
        return index;
      default:
        index = 2;
        return index;
    }
  }

  _focus() {
    this._Column.selectedIndex = this._setManualFocus();
  }

  $unselectCurrentIndex() {
    this._Column.items[this._index]._unfocus();
  }
  _handleHover() {
    return false;
  }

  _handleUnhover() {
    return false;
  }

  get _Column() {
    return this.tag('Column');
  }
  _getFocused() {
    return this._Column;
  }
}
